import React from "react";
import RewardSystemOverviewView from "../components/reward-system-overview-view";
import { withApollo } from '@apollo/client/react/hoc';
import { compose } from "modules/core";
import { REWARD_OVERVIEW } from "../graphql/rewardSubscription.gql";
import moment from "moment-timezone";

const RewardSystemOverviewContainer = (props) => {
  const { client, rewardPermission } = props;
  const [overviewData, setOverviewData] = React.useState({
    totalPoints: 0,
    pointsForWeek: 0,
    recentAchievements: [],
    overviewList: []
  });
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    if (rewardPermission && rewardPermission.reward_overview_permissions)
      getOverviewData();
    else if (rewardPermission && rewardPermission.reward_overview_permissions === false)
      setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rewardPermission]);

  const getOverviewData = async () => {
    try {
      const { data } = await client.query({
        query: REWARD_OVERVIEW,
        fetchPolicy: 'network-only',
        variables: {
          dateRange: [
            moment().startOf('isoWeek').toISOString(),
            moment().toISOString()
          ]
        }
      });
      if (data) {
        const lastWeekPoints = data?.points_for_week?.edges.reduce((acc, { node }) => acc + node.points, 0) || 0;
        const recentActivities = data?.recent_achivement?.edges.map(({ node }) => ({ action: node.rule.category.name, points: node.points, date: node.earnedAt })) || [];
        const overviewList = data?.overview_list || [];
        setOverviewData({
          totalPoints: data.total_points_earned,
          pointsForWeek: lastWeekPoints,
          recentAchievements: recentActivities,
          overviewList: overviewList
        })
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching reward data:", error);
      setLoading(false);
    }
  }
  return (
    <RewardSystemOverviewView loading={loading} overviewData={overviewData} permission={rewardPermission?.reward_overview_permissions} />
  );
}

export default compose(withApollo)(RewardSystemOverviewContainer);